import { AccountUsage } from '../../../accountSettings/api/getAccountUsage'

export const getCurrentVisitsCount = (
  accountUsage: AccountUsage | undefined,
  product: string
): number | undefined => {
  return accountUsage?.find((item) => item.product === product)?.visitsCount
}

export const geteMinimumPlanVisitsByCurrentUsage = (
  currentUsage: number,
  botMitigationPlanSizes: number[]
): number => {
  // Normalize values
  const adjustedPlanSizes = botMitigationPlanSizes.map((size) => size * 1000)

  // Find the correct range for the current visits amount
  for (const plan of adjustedPlanSizes) {
    if (currentUsage <= plan) {
      return plan
    }
  }

  // If currentUseCountcurrentUseCount exceeds all plans, return the largest plan size
  return adjustedPlanSizes[adjustedPlanSizes.length - 1]
}
